/*
 * Ekim 2026 – Ürün kartlarında hızlı sepete ekleme.
 * Kart bilgisinin sağ altında "+" düğmesi (snippets/product-block.liquid → .hz-ekle.hz-ekle--alt; görünüm assets/kart-sade.css).
 * Bedeni olan üründe görselin altında beden seçimi açılır; seçilen beden sepete eklenir ve sepet açılır.
 * Tek seçenekli ürün doğrudan eklenir. Tema olayları: dispatch:cart-drawer:refresh / :open (assets/custom.js).
 */
(function () {
  if (window.hzEkle) return;
  window.hzEkle = true;

  const en = (document.documentElement.lang || '').toLowerCase().startsWith('en');
  const yazi = en
    ? { sec: 'Select size', eklendi: 'Added to bag', hata: 'Could not add', ekle: 'Add to bag', tukendi: 'Sold out' }
    : { sec: 'Beden seç', eklendi: 'Sepete eklendi', hata: 'Eklenemedi', ekle: 'Sepete ekle', tukendi: 'Tükendi' };

  const css = `
  .image-cont { position: relative; }
  .hz-ekle { position: absolute; top: 10px; right: 10px; z-index: 4; display: inline-flex; align-items: center; justify-content: center; width: 36px; height: 36px; padding: 0; border: 1px solid rgb(48 47 47 / .22); border-radius: 50%; background: rgb(255 255 255 / .9); color: rgb(48 47 47); cursor: pointer; transition: border-color .2s, background .2s, transform .2s; -webkit-tap-highlight-color: transparent; }
  .hz-ekle:hover { border-color: rgb(48 47 47 / .55); background: #fff; }
  .hz-ekle.is-acik { background: #F3F1EE; border-color: #F3F1EE; }
  .hz-ekle.is-bekliyor { pointer-events: none; opacity: .6; }
  .hz-ekle svg { width: 17px; height: 17px; }
  .hz-tepsi { position: absolute; left: 8px; right: 8px; bottom: 8px; z-index: 5; padding: 12px 12px 10px; background: rgb(255 255 255 / .96); border-radius: 12px; box-shadow: 0 8px 24px rgb(48 47 47 / .10); color: rgb(48 47 47); opacity: 0; transform: translateY(6px); transition: opacity .2s, transform .2s; pointer-events: none; }
  .hz-tepsi.is-acik { opacity: 1; transform: none; pointer-events: auto; }
  .hz-tepsi__baslik { margin: 0 0 9px; font-family: var(--heading-font-family, Cormorant, serif); font-size: 11.5px; letter-spacing: .16em; text-transform: uppercase; text-align: center; }
  .hz-tepsi__bedenler { display: flex; flex-wrap: wrap; justify-content: center; gap: 6px; }
  .hz-beden { min-width: 38px; padding: 6px 9px; border: 1px solid rgb(48 47 47 / .18); border-radius: 18px; background: #fff; color: rgb(48 47 47); font: inherit; font-size: 12px; letter-spacing: .02em; line-height: 1.2; cursor: pointer; transition: border-color .15s, background .15s; }
  .hz-beden:hover:not([disabled]) { border-color: rgb(48 47 47 / .6); }
  .hz-beden.is-secili { background: #DEDAD4; border-color: #DEDAD4; }
  .hz-beden[disabled] { opacity: .35; text-decoration: line-through; cursor: default; }
  .hz-tepsi__durum { margin: 0; font-size: 12px; text-align: center; letter-spacing: .04em; }
  @media (max-width: 767.98px) {
    .hz-ekle { top: 7px; right: 7px; width: 32px; height: 32px; }
    .hz-ekle svg { width: 15px; height: 15px; }
    .hz-tepsi { left: 5px; right: 5px; bottom: 5px; padding: 10px 8px 8px; }
    .hz-beden { min-width: 32px; padding: 5px 7px; font-size: 11px; }
  }`;
  const st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  const urunler = {};
  const urunGetir = (h) => urunler[h] || (urunler[h] = fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}products/${h}.js`).then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); }));
  const bedenIndex = (p) => p.options.findIndex((o) => /beden|size|ölçü/i.test(typeof o === 'string' ? o : o.name));

  let acikTepsi = null;
  const kapat = () => { if (!acikTepsi) return; acikTepsi.classList.remove('is-acik'); acikTepsi.dugme.classList.remove('is-acik'); acikTepsi = null; };

  const durumYaz = (tepsi, metin) => { tepsi.innerHTML = `<p class="hz-tepsi__durum">${metin}</p>`; };

  async function ekle(id, dugme, tepsi) {
    dugme.classList.add('is-bekliyor');
    try {
      const r = await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || yazi.hata);
      if (tepsi) durumYaz(tepsi, '✓ ' + yazi.eklendi);
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      setTimeout(() => { kapat(); document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: dugme } })); }, tepsi ? 600 : 0);
    } catch (e) {
      if (tepsi) durumYaz(tepsi, e.message || yazi.hata); else alert(e.message || yazi.hata);
    } finally { dugme.classList.remove('is-bekliyor'); }
  }

  document.addEventListener('click', async (e) => {
    const dugme = e.target.closest('.hz-ekle');
    if (!dugme) { if (acikTepsi && !e.target.closest('.hz-tepsi')) kapat(); return; }
    e.preventDefault(); e.stopPropagation();
    // Beden tepsisi her zaman ürün görselinin üstünde açılır (düğme 23.10'dan beri görselin dışında, kart bilgisinde)
    // 26.10: favoriler sayfasındaki kartlar da aynı düğme/tepsiyi kullanır (data-hz-kart / data-hz-gorsel, assets/favori-sayfa.js)
    const blok = dugme.closest('.product-block, [data-hz-kart]');
    const kap = dugme.closest('.image-cont') || (blok && blok.querySelector('.image-cont, [data-hz-gorsel]')) || dugme.parentElement;
    let tepsi = kap.querySelector(':scope > .hz-tepsi');
    if (tepsi && tepsi === acikTepsi) { kapat(); return; }
    kapat();
    dugme.classList.add('is-bekliyor');
    let p;
    try { p = await urunGetir(dugme.dataset.handle); } catch (err) { dugme.classList.remove('is-bekliyor'); window.location.href = dugme.dataset.url || '#'; return; }
    dugme.classList.remove('is-bekliyor');
    const bi = bedenIndex(p);
    const varyantlar = p.variants;
    if (bi < 0 || varyantlar.length === 1) {
      const v = varyantlar.find((x) => x.available);
      if (v) ekle(v.id, dugme, null);
      return;
    }
    const degerler = [...new Set(varyantlar.map((v) => v.options[bi]))];
    if (!tepsi) {
      tepsi = document.createElement('div'); tepsi.className = 'hz-tepsi';
      kap.appendChild(tepsi);
    }
    tepsi.dugme = dugme;
    tepsi.innerHTML = `<p class="hz-tepsi__baslik">${yazi.sec}</p><div class="hz-tepsi__bedenler">${degerler.map((d) => {
      const v = varyantlar.find((x) => x.options[bi] === d && x.available);
      return `<button type="button" class="hz-beden" ${v ? `data-id="${v.id}"` : 'disabled'} aria-label="${d}${v ? '' : ' – ' + yazi.tukendi}">${d}</button>`;
    }).join('')}</div>`;
    tepsi.onclick = (ev) => {
      const b = ev.target.closest('.hz-beden'); if (!b || b.disabled) return;
      ev.preventDefault(); ev.stopPropagation();
      b.classList.add('is-secili');
      ekle(Number(b.dataset.id), dugme, tepsi);
    };
    requestAnimationFrame(() => { tepsi.classList.add('is-acik'); dugme.classList.add('is-acik'); acikTepsi = tepsi; });
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') kapat(); });
})();
